import React, { createContext, useContext, useState, useEffect } from 'react';

// Create the context
const PackContext = createContext();

// Context provider component
export const PackProvider = ({ children }) => {
  const [selectedPack, setSelectedPack] = useState('capital');
  const [isLoading, setIsLoading] = useState(false);

  // Initialize pack from localStorage or default to 'capital'
  useEffect(() => {
    try {
      const storedPack = localStorage.getItem('selectedPack');
      if (storedPack) {
        setSelectedPack(storedPack);
      }
    } catch (error) {
      console.warn('Failed to load pack from localStorage:', error);
      // Use default 'capital' pack
      setSelectedPack('capital');
    }
  }, []);

  // Save pack selection to localStorage
  const selectPack = (packName) => {
    try {
      setSelectedPack(packName);
      localStorage.setItem('selectedPack', packName);
    } catch (error) {
      console.warn('Failed to save pack to localStorage:', error);
      // Still update state even if localStorage fails
      setSelectedPack(packName);
    }
  };

  return (
    <PackContext.Provider value={{
      selectedPack,
      selectPack,
      isLoading,
      setIsLoading,
      // Add aliases for backward compatibility
      activePack: selectedPack,
      setActivePack: selectPack
    }}>
      {children}
    </PackContext.Provider>
  );
};

// Custom hook to use the context
export const usePackContext = () => {
  const context = useContext(PackContext);
  if (!context) {
    throw new Error('usePackContext must be used within a PackProvider');
  }
  return context;
};

// Fixed usePack hook to properly return context values
export const usePack = () => {
  const context = useContext(PackContext);
  if (!context) {
    throw new Error('usePack must be used within a PackProvider');
  }
  return context;
};

export default PackContext;